import styled from "@emotion/styled";
import { ButtonVariant } from "../../../interfaces";

export const StyledButton = styled.button<{
  $variant: ButtonVariant;
  $fullWidth?: boolean;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: 2.5rem;
  padding: 0 ${({ theme }) => theme.spacing.md};
  font-family: inherit;
  font-size: ${({ theme }) => theme.typography.sizes.md};
  font-weight: 500;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  gap: ${({ theme }) => theme.spacing.sm};
  cursor: pointer;
  transition: all 0.2s ease;
  border: 0.0625rem solid transparent;

  width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "auto")};

  background-color: ${({ theme, $variant }) => {
    if ($variant === "danger") return theme.colors.danger;
    if ($variant === "success") return theme.colors.success;
    if ($variant === "secondary") return "transparent";
    return theme.colors.primary;
  }};

  color: ${({ theme, $variant }) => {
    if ($variant === "secondary") return theme.colors.text;
    if ($variant === "danger" || $variant === "success") return "#ffffff";
    return theme.colors.primaryForeground;
  }};

  border-color: ${({ theme, $variant }) => {
    if ($variant === "secondary") return theme.colors.border;
    return "transparent";
  }};

  &:hover {
    opacity: 0.9;
    background-color: ${({ theme, $variant }) => {
      if ($variant === "secondary") return theme.colors.surface;
      return undefined;
    }};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;
